export const environment = {
  production: false,
  BASE_API: 'https://wnioski-stage.empatia.gov.pl/api',
  API_EWNIOSKI: 'https://wnioski-stage.empatia.gov.pl/api/ewnioski',
  API_KREATORY: 'https://wnioski-stage.empatia.gov.pl/api/kreatory',
  KREATORY_FE: 'https://wnioski-stage.empatia.gov.pl/kreatory',
  LIFERAY_PIU_HOME_PAGE_URL: 'https://stage.empatia.gov.pl/',
  APP_VERSION: '1.0.5',
  QUALIFIED_SIGNATRE_AUTH_VISIBLE: false,
};
